import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { TableChart, ViewKanban } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/common/Loader";
import { useGetSubmissionsQuery } from "../../services/submissions.service";
import { useGetUsersQuery } from "../../services/users.service";
import SubmissionsTable from "../../components/Submissions/Table";
import SubmissionsKanban from "../../components/Submissions/SubmissionsKanban";

type View = "table" | "kanban";

function SubmissionsPage() {
  const navigate = useNavigate();
  const [view, setView] = useState<View>("table");

  const { data: submissions, error: submissionsError, isLoading: isLoadingSubmissions } = useGetSubmissionsQuery("Submissions");
  const { data: users, error: usersError, isLoading: isLoadingUsers } = useGetUsersQuery("Users");

  const isLoading = isLoadingSubmissions || isLoadingUsers;

  if (submissionsError || usersError) {
    navigate("/");
  }

  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column" gap={1.5}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
        <ToggleButtonGroup
          size="small"
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          sx={{ height: 36 }}
        >
          <ToggleButton value="table" sx={{ px: 1.5, gap: 0.5, fontSize: "0.75rem", fontWeight: 600, textTransform: "none" }}>
            <TableChart fontSize="small" />
            Table
          </ToggleButton>
          <ToggleButton value="kanban" sx={{ px: 1.5, gap: 0.5, fontSize: "0.75rem", fontWeight: 600, textTransform: "none" }}>
            <ViewKanban fontSize="small" />
            Kanban
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box flex={1} minHeight={0}>
        {isLoading ? (
          <Loader />
        ) : view === "table" ? (
          <SubmissionsTable users={users!} rows={submissions as any} />
        ) : (
          <SubmissionsKanban users={users!} rows={submissions as any} />
        )}
      </Box>
    </Box>
  );
}

export default SubmissionsPage;
